import { useTranslation } from "react-i18next";
import { useGlobalContext } from "../../../../stores/Global";
import { useNavigate } from "react-router";
import { useState } from "react";
import DataView, { QueryParameters } from "../../../organisms/DataView";
import { PaginatedListWebhook, Webhook } from "../../../../services/swagger";
import { WebhookService } from "../../../../services/api";
import { Chip, TableCell } from "@mui/material";
import ItemCard from "../../../organisms/ItemCard";
import { useQuery } from "@tanstack/react-query";

export default function WebhookSettingsPage() {
  const { t } = useTranslation("WebhookSettingsPage");
  const { context } = useGlobalContext();
  const navigate = useNavigate();
  const [query, setQuery] = useState<QueryParameters>();

  const loadWebhooks = async (): Promise<PaginatedListWebhook | null> => {
    if (!query) return null;
    const res = await WebhookService.getWebhookList({
      search: query.search,
      limit: query.limit,
      skip: query.skip,
      filters: query.filters,
      sortDirection: query.sortDirection,
      sortField: query.sortField,
    });
    if (res?.data?.data) return res.data.data;
    else return null;
  };

  const { data, isLoading } = useQuery({
    queryKey: ["webhook-settings", { query }],
    queryFn: loadWebhooks,
    refetchInterval: 1000 * 10,
    refetchOnMount: true,
    refetchOnWindowFocus: true,
    placeholderData: (previousData) => previousData,
    maxPages: 10,
  });

  const navigateToWebhook = (webhook: Webhook) => {
    navigate(`/m/settings/integrations/webhooks/${webhook._id}`);
  };

  const handleDataTableChange = (query: QueryParameters) => {
    setQuery(query);
  };

  return (
    <>
      <DataView
        name={t("Webhooks")}
        loading={isLoading || !data}
        button={{
          text: t("NewWebhook"),
          onClick: () => navigate("/m/settings/integrations/webhooks/create"),
        }}
        onItemClick={(item) => navigateToWebhook(item)}
        pagination
        count={data?.count || 0}
        items={context.user ? data?.docs || [] : []}
        headers={[
          {
            field: "description",
            name: t("Description"),
            type: "string",
          },
          {
            field: "url",
            name: t("Url"),
            type: "string",
          },
          {
            field: "enabled",
            name: t("Enabled"),
            type: "other",
            renderRowCell: (row: Webhook) => {
              return (
                <TableCell>
                  <Chip
                    label={row.enabled ? t("Enabled") : t("Disabled")}
                    color={row.enabled ? "success" : "default"}
                  />
                </TableCell>
              );
            },
          },
        ]}
        onChange={handleDataTableChange}
        renderItem={(webhook) => (
          <ItemCard
            webhook={webhook}
            onClick={() => navigateToWebhook(webhook)}
          />
        )}
      />
    </>
  );
}
